import { notification } from 'antd';
import { API_BASE_URL } from '../config';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import { PageBody, PageHead } from '../layout';
import { Callout, UploadDropzone } from '../components/ui';

const UploadGoScores = () => {
  function onChange(info: UploadChangeParam<UploadFile<any>>) {
    if (info.file.status === 'done') {
      notification.success({ message: 'GoScores successfully uploaded.' });
    } else if (info.file.status === 'error') {
      notification.error({ message: 'GoScores failed to upload.' });
    }
  }

  return (
    <>
      <PageHead title="GoScores" subtitle="Bulk upload GoValue scores from CSV." />
      <PageBody>
        <div className="flex flex-col gap-4">
          <Callout tone="info">
            The uploaded CSV must have the columns <strong>domain_name</strong> and{' '}
            <strong>govalue</strong>.
          </Callout>
          <p className="text-text-2 text-[12.5px]">Drop a file here with GoScores.</p>
          <UploadDropzone
            action={API_BASE_URL + '/v1/goscores'}
            onChange={onChange}
          />
        </div>
      </PageBody>
    </>
  );
};

export default UploadGoScores;
